import { persist } from 'zustand/middleware';
import { LOCAL_STORAGE_KEYS } from '@namespace/helpers';
import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';

const initialState = {
  basketNumber: 0,
  nonEmptyBaskets: []
};

export const useBetslipLsStore = createHookStore(
  STORE_NAMES.BETSLIP_LS,
  initialState,
  [[persist, { name: LOCAL_STORAGE_KEYS.BETSLIP_LS_STORE }]]
);
